import "./home.css"

export const Home = () => {
  return (
    <section className="presentation">
      <div className="presentationText">
        <p>
          Hello World <span>Im Joseph</span> Frontend Developer Junior
        </p>
        <a href="https://drive.google.com/file/d/1hGZy-_mW9Djwc1EeORuopI3q6OzEpNCG/view?usp=sharing" target="_blank" rel="nopener noreferrer">
          <button className="cvDownloadBtn">DOWNLOAD CV</button>
        </a>
      </div>
      <div className="presentationImage">
        <img
          src="./images/presentation-picture.png"
          alt="Joseph smiling"
        />
      </div>
    </section>
  );
};
